// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h7-j";
export var fulfillmentFormRail = "_h7-i";
export var headerTitleRow = "_h7-l";
export var orderDetailsWrapper = "_h7-g";
export var orderLinkTrigger = "_h7-2";
export var paymentInformationGrid = "_h7-q";
export var paymentSummaryColumn = "_h7-r";
export var phoneShipmentPickerButton = "_h7-e";
export var phoneShipmentPickerButtonContent = "_h7-f";
export var phoneShipmentPickerButtonWrapper = "_h7-d";
export var phoneShipmentPickerTrigger = "_h7-c";
export var shipmentContainer = "_h7-k";
export var shipmentDetailsMainPane = "_h7-h";
export var shipmentNavigationCard = "_h7-a";
export var shipmentNavigationEdgeTrigger = "_h7-6";
export var shipmentNavigationRail = "_h7-3";
export var shipmentNavigationRailEnter = "_h7-5";
export var shipmentNavigationRailHeader = "_h7-9";
export var shipmentNavigationRailOverlay = "_h7-4";
export var shipmentNavigationScrim = "_h7-7";
export var shipmentSummaryFact = "_h7-n";
export var shipmentSummaryGrid = "_h7-m";
export var shipmentSummaryMetadataRow = "_h7-o";
export var shipmentSummaryTags = "_h7-p";
export var shipmentWorkspace = "_h7-0";
export var shipmentWorkspaceBodyTablet = "_h7-8";
export var shipmentWorkspaceContent = "_h7-b";
export var shipmentWorkspaceHeader = "_h7-1";